import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoriesWithProblemsResponse } from '@app/admin/shared/models/categories-with-problems-response';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProblemService {
  private url: string = environment.apiUrl + '/problem';

  constructor(private httpClient: HttpClient) { }

  getCategoriesWithProblems(): Observable<CategoriesWithProblemsResponse> {
    return this.httpClient.get<CategoriesWithProblemsResponse>(`${this.url}/categoriesWithProblems`);
  }

  getCategoriesWithDeletedProblems(): Observable<CategoriesWithProblemsResponse> {
    const url = `${this.url}/categoriesWithProblems`;

    const queryParams = new HttpParams()
      .set("includeDeletedProblems", true);

    return this.httpClient.get<CategoriesWithProblemsResponse>(url, { params: queryParams });
  }
}
